import { Filters } from '../../../model/Filters'

const all = ['patientTreatments']
const lists = (patientId: number) => [...all, patientId, 'lists']
const list = (patientId: number, filters?: Filters) => [...lists(patientId), filters]

export const patientTreatmentsKeys = { all, lists, list }
